import { render } from "./SportHighlights.vue?vue&type=template&id=6922ac21&scoped=true"
import script from "./SportHighlights.vue?vue&type=script&lang=js"
export * from "./SportHighlights.vue?vue&type=script&lang=js"

import "./SportHighlights.vue?vue&type=style&index=0&id=6922ac21&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6922ac21"]])

export default __exports__